import { get } from "~/lib/helpers/objects";
import {getPublicCustomisation} from "./service";
import {createAuthListener} from "~/modules/auth/store";

const defaultsCommandsColor = {
  default: "#1D345B",
  hover: "#fff",
  active: "#fff",
};

export default {

  state: {
    data: null
  },

  getters: {
    customisation: state => path => {
      const requestedValue = get(state.data, path);
      if (typeof requestedValue === "undefined") {
        return null;
      }
      return requestedValue;
    },
    customisationSchema: state => ({...state.data})
  },

  mutations: {
    setCustomisation: (state, customisation) => {
      state.isLoading = false;
      state.isErrored = false;
      state.data = {
        ...customisation,
        colors: {
          ...customisation.colors,
          commands: {
            ...defaultsCommandsColor,
            ...(customisation.colors.commands ? customisation.colors.commands : {})
          }
        }
      };
    },
    clearCustomisation: state => {
      state.data = null;
    }
  },
  actions: {
    storeInit(store) {
      createAuthListener({
        onLogin: event => store.commit("setCustomisation", event.detail.customisation),
        onLogout: () => store.commit("clearCustomisation")
      });
    },
    async fetchSharedCustomisation(store, clientUuid) {
      try {
        const customisation = await getPublicCustomisation(clientUuid);
        store.commit("setCustomisation", customisation);
      } catch (err) {
        console.warn("unable to fetch customisation");
      }
    }
  }
};
